import { getCustomers } from "@/api/customerAPI";
import { getAllProductInstances } from "@/api/productAPI";
import { getSidebarCustomers, getSidebarEntries } from "@/api/sidebarEntryAPI";
import { queryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { type User, getUserById } from "./userAPI";

function customersOptions() {
    return queryOptions({
        queryKey: ["customers"],
        queryFn: () => getCustomers(),
    });
}

function userByIdOptions({ id }: { id: number | null }) {
    return queryOptions<User, AxiosError>({
        queryKey: ["user", id],
        queryFn: async () => (id ? await getUserById(id) : ({} as User)),
        enabled: !!id,
    });
}

function productInstancesOptions() {
    return queryOptions({
        queryKey: ["productInstances"],
        queryFn: () => getAllProductInstances(),
    });
}

function sidebarEntriesOptions(customerId?: number) {
    return queryOptions({
        queryKey: ["sidebarEntries", customerId],
        queryFn: () => {
            if (customerId === undefined) {
                throw new Error("customerId is required to load sidebar entries");
            }

            return getSidebarEntries(customerId);
        },
        enabled: customerId !== undefined,
    });
}

function sidebarCustomersOptions() {
    return queryOptions({
        queryKey: ["sidebarCustomers"],
        queryFn: () => getSidebarCustomers(),
    });
}

export {
    customersOptions,
    productInstancesOptions,
    sidebarCustomersOptions,
    sidebarEntriesOptions,
    userByIdOptions,
};
